const APPS = {
  ALARM_APP: 'com__dot__maxcom__dot__alarm',
  SYNCHRO_APP: 'pl__dot__maxcom__dot__synchro',
  LOCATION_APP: 'pl__dot__maxcom__dot__location',
  SOS_APP: 'com__dot__maxcom__dot__emergency',
  SETTINGS_APP: 'com__dot__maxcom__dot__maxcomsettings',
  DIALER_APP: 'com__dot__maxcom__dot__dialer',

  HISTORY_APP: 'pl__dot__maxcom__dot__history',
  CONTACTS_APP: 'pl__dot__maxcom__dot__contacts',
};

export default APPS;



// WEBPACK FOOTER //
// ./src/const/apps.js